import {useSelector} from 'react-redux';

import {
	contactListAccessViewRoles,
	dashboardAccessViewRoles,
	groupRiskAssessmentAccessViewRoles
} from '../../../util/uiconstants';

export const getAccessPermissions = ({userId, project}) => {
	const user = project?.users?.find((user) => user.userId === userId);
	const isProjectOwner = !!user?.isProjectOwner || project?.owners?.find((user) => user.userId === userId);

	const hasDashboardRoles = !!user?.roles?.some((role) => dashboardAccessViewRoles.includes(role));
	const hasGroupRiskRoles = !!user?.roles?.some((role) => groupRiskAssessmentAccessViewRoles.includes(role));
	const hasContactListRoles = !!user?.roles?.some((role) => contactListAccessViewRoles.includes(role));

	const isGroupRiskAssessmentProject = project?.isGroupRiskAssessmentProject;

	const isActiveProject = project?.status === 'active';

	return {
		dashboardAccess: (isProjectOwner || hasDashboardRoles) && isActiveProject,
		groupRiskAssessmentAccess: (isProjectOwner || hasGroupRiskRoles) && isActiveProject && isGroupRiskAssessmentProject,
		contactListAccess: (isProjectOwner || hasContactListRoles) && isActiveProject
	};
};

export default (specificProject = null) =>
	useSelector(({newProject, project, userPreferences}) => {
		let actualProject = project;
		if (newProject.Id !== '') actualProject = newProject;
		if (specificProject) actualProject = specificProject;

		return getAccessPermissions({
			userId: userPreferences.userId,
			project: {...actualProject}
		});
	});
